import { IDadosAnaliticos } from '../interface/apiInterface';
import { IAnaliticData } from '../interface/reduxInterface';

export function returnArray(array: IDadosAnaliticos[]): IAnaliticData[] {
  const newArray = array.map((item: IDadosAnaliticos) => {
    const data: IAnaliticData = {
      id: item.id,
      description: item.hist,
      messageCode: item.cod_msg,
      transactionProtocolNumber: item.numCtrlIF,
      jdCabineProtocolNumber: item.NumCtrlSTR,
      partnerId: item.id_usuario,
      bankIdDebited: item.ISPBIFDebtd,
      customerIdDebited: item.id_cliente_debtd,
      customerNameDebited: item.nome_cliente_debito,
      customerCnpjCpfDebited: item.cnpj_cpf_debito,
      agencyDebited: item.agDebtd,
      accountTypeDebited: item.tpCtDebitada,
      accountDebited: item.ctDebtd,
      legalEntityDebited: item.TpPessoaDebtd,
      creditedBankId: item.ISPBIFCredtd,
      customerCnpjCpfCredited: item.cnpj_cpf_clienteCredtada,
      customerNameCredited: item.nome_clienteCredtada,
      agencyCredited: item.agCredtda,
      accountTypeCredited: item.tpCtCredtda,
      accountCredited: item.ctCredtda,
      legalEntityCredited: item.tpPessoaCredtda,
      value: item.valor_lancamento,
      transactionDate: item.dt_movto,
      transactionStatus: item.TpRetorno,
      createdAt: item.created_at,
      updatedAt: item.updated_at,
    };
    return data;
  });
  return newArray;
}

export function treatApiResponse(
  apiResponse: any,
  priority: string
): IAnaliticData[] {
  let array: IAnaliticData[];

  const hasMovimentadas = Object.prototype.hasOwnProperty.call(
    apiResponse,
    'movimentadas'
  );

  const hasTarifasPagasTransf = Object.prototype.hasOwnProperty.call(
    apiResponse,
    'pagas_transf'
  );

  const hasPagamentosRecebidos = Object.prototype.hasOwnProperty.call(
    apiResponse,
    'pagamentos_recebidos'
  );

  const hasEnviadas = Object.prototype.hasOwnProperty.call(
    apiResponse,
    'enviadas'
  );
  const hasRecebidas = Object.prototype.hasOwnProperty.call(
    apiResponse,
    'recebidas'
  );
  const hasPagas = Object.prototype.hasOwnProperty.call(apiResponse, 'pagas');

  const hasPagamentos = Object.prototype.hasOwnProperty.call(
    apiResponse,
    'pagamentos'
  );
  const hasRecarga = Object.prototype.hasOwnProperty.call(
    apiResponse,
    'recarga'
  );
  const hasLiquidados = Object.prototype.hasOwnProperty.call(
    apiResponse,
    'liquidados'
  );
  const hasPagasFiducia = Object.prototype.hasOwnProperty.call(
    apiResponse,
    'pagas_fiducia'
  );

  if (hasMovimentadas) {
    array = returnArray(apiResponse.movimentadas);
    return array;
  }

  if (hasEnviadas && hasRecebidas) {
    switch (priority) {
      case 'sended':
        array = returnArray(apiResponse.enviadas);
        return array;

      default:
        array = returnArray(apiResponse.recebidas);
        return array;
    }
  }

  if (hasEnviadas) {
    array = returnArray(apiResponse.enviadas);
    return array;
  }

  if (hasPagamentosRecebidos) {
    array = returnArray(apiResponse.pagamentos_recebidos);
    return array;
  }
  if (hasTarifasPagasTransf) {
    array = returnArray(apiResponse.pagas_transf);
    return array;
  }

  if (hasRecebidas) {
    array = returnArray(apiResponse.recebidas);
    return array;
  }
  if (hasPagas) {
    array = returnArray(apiResponse.pagas);
    return array;
  }
  if (hasPagamentos) {
    array = returnArray(apiResponse.pagamentos);
    return array;
  }
  if (hasRecarga) {
    array = returnArray(apiResponse.recarga);
    return array;
  }
  if (hasLiquidados) {
    array = returnArray(apiResponse.liquidados);
    return array;
  }
  if (hasPagasFiducia) {
    array = returnArray(apiResponse.pagas_fiducia);
    return array;
  }
  array = returnArray(apiResponse.tarifa_recebidas);
  return array;
}
